import { MaybeUndef } from 'types/UtilityTypes';

/**
 * Equipment the Stark integration accepts. The backend
 * (mapTransportTypeToStarkEquipment) maps these to Stark's 53' van, reefer
 * and flatbed keys.
 */
export const STARK_EQUIPMENT_OPTIONS = [
  { value: 'Van', label: 'Van' },
  { value: 'Reefer', label: 'Reefer' },
  { value: 'Flatbed', label: 'Flatbed' },
];

/**
 * The Stark equipment option a suggested transport type names exactly (case
 * aside: VAN, Reefer, FLATBED), or '' so the rep picks one. Hydration is a
 * pass-through: no substring guesses, since mapping belongs to the backend.
 */
export function normalizeStarkTransportType(
  transportType: MaybeUndef<string>
): string {
  const lower = String(transportType ?? '')
    .trim()
    .toLowerCase();
  const option = STARK_EQUIPMENT_OPTIONS.find(
    ({ value }) => value.toLowerCase() === lower
  );
  return option?.value ?? '';
}
